import React, { useEffect, useState } from "react";
import { FaSave, FaSearch, FaTrash } from "react-icons/fa";
import es_ES from "rsuite/locales/es_ES";
import {
  Modal,
  Panel,
  DatePicker,
  Text,
  InputNumber,
  Button,
  Table,
  Input,
  toaster,
  Message,
  SelectPicker,
  CustomProvider,
} from "rsuite";
import moment from "moment/moment";
import {
  cancelHorario,
  eliminaHorarios,
  getHorariosServicio,
  saveHorario,
} from "./Services/HorariosServices";

const { Column, HeaderCell, Cell } = Table;

export const Horarios = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [fec1, setFec1] = useState("");
  const [fec2, setFec2] = useState("");
  const [del, setDel] = useState(moment(new Date()).format("DD/MM/YYYY"));
  const [al, setAl] = useState(moment(new Date()).format("DD/MM/YYYY"));
  const [duracion, setDuracion] = useState(null);
  const [horaIni, setHoraIni] = useState("");
  const [horaFin, setHoraFin] = useState("");
  const [horaIniCom, setHoraIniCom] = useState("");
  const [horaFinCom, setHoraFinCom] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [habilitarElimina, setHabilitarElimina] = useState(true);
  const [pregunta, setPregunta] = useState("");
  const [disabledSi, setDisabledSi] = useState(false);
  const [dataCondcion] = useState([
    { label: "Sin selección", value: "SinSelecc"},
    { label: "Excluir fines de semana", value: "excludFS" },
    { label: "Solo sábados", value: "soloSAB" },
  ]);
  const [condicion, setCondicion] = useState("SinSelecc");
  const [dataFiltro] = useState([
    { label: "Todos los Lunes", value: "LUNES" },
    { label: "Todos los Martes", value: "MARTES" },
    { label: "Todos los Míercoles", value: "MIÉRCOLES" },
    { label: "Todos los Jueves", value: "JUEVES" },
    { label: "Todos los Viernes", value: "VIERNES" },
    { label: "Todos los Sábados", value: "SÁBADO" },
  ]);
  const [filtro, setFiltro] = useState("0");
  const [openElimina, setoOpenElimina] = useState(false);

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  };

  const maskTime = (value, opc) => {
    if (opc === "ini") {
      setHoraIni(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2")
      );
    }
    if (opc === "fin") {
      setHoraFin(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2")
      );
    }
    if (opc === "iniCom") {
      setHoraIniCom(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2")
      );
    }
    if (opc === "finCom") {
      setHoraFinCom(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2")
      );
    }
  };

  const getHorarios = async () => {
    if(del===null || f2===null) { return;}
    var f1 = new Date(del).toISOString().substring(0, 10);
    var f2 = new Date(al).toISOString().substring(0, 10);

    if (filtro === "" || filtro === null) {
      setTimeout(() => {
        setFiltro("0");
      }, [500]);
    }

    setDataLoading(true);
    await getHorariosServicio(idNegocio, f1, f2, filtro)
      .then((res) => {
        setData(res);
        setDataLoading(false);
        if (res.length > 0) setHabilitarElimina(false);
      })
      .finally((end) => {
        setDataLoading(false);
      });
  };

  const save = async () => {
    setLoading(true);
    const data = {
      id: idNegocio,
      del: moment(fec1).format("YYYY-MM-DD"),
      al: moment(fec2).format("YYYY-MM-DD"),
      duracion: duracion,
      horaIni: horaIni,
      horaFin: horaFin,
      horaIniCom: horaIniCom,
      horaFinCom: horaFinCom,
      condicion: condicion,
    };

    await saveHorario(data)
      .then((res) => {
        if (res.data > 0) {
          toast("Los datos se han actualizado de forma correcta.", "success");
          setFec1("");
          setFec2("");
          setDuracion("");
          setHoraIni("");
          setHoraFin("");
          setHoraIniCom("");
          setHoraFinCom("");
          setLoading(false);
        } else {
          toast("Ocurrio un error al guardar el horario.", "warning");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const cancelarHorario = async (props) => {
    const _fec = moment(props.fecha, "DD-MM-YYYY").toDate();

    const data = {
      id: idNegocio,
      del: _fec,
      al: _fec,
      espacio: props.espacio,
      duracion: 0,
      horaIni: props.hora,
      horaFin: "00:00",
      horaIniCom: "00:00",
      horaFinCom: "00:00",
    };

    await cancelHorario(data).then((res) => {
      console.log(res);
      if (res.data === 1) {
        toast("El horario se ha cancelado de forma correcta.", "success");
        getHorarios();
      }
      if (res.data === -1) {
        toast(
          "El horario no puede ser cancelado, la fecha es menor a la actual.",
          "error"
        );
      }
      if (res.data === -2) {
        toast(
          "El horario no puede ser cancelado, la hora es menor a la actual.",
          "error"
        );
      }
      if (res.data === -3) {
        toast(
          "El horario no puede ser cancelado, se encuentra ocupado.",
          "error"
        );
      }
    });
  };

  const handleOpenElimina = () => {
    const _f1 = moment(del).format("DD-MMM-YYYY");
    const _f2 = moment(al).format("DD-MMM-YYYY");
    setDisabledSi(false);
    setPregunta(`¿Deseas eliminar los horarios con el rango de fechas: Del ${_f1} al ${_f2}?`);
    setoOpenElimina(true);
  }

  const deleteHorarios = async () => {
    setDisabledSi(true);
    const data = {
      id: idNegocio,
      del: moment(del).format("YYYY-MM-DD"),
      al: moment(al).format("YYYY-MM-DD"),
    };

    await eliminaHorarios(data).then(res => {
      if(res.data > 0){
        toast(`Se han eliminado: ${res.data}, registro(s).`,"success");
        setHabilitarElimina(true);
        setoOpenElimina(false);
        getHorarios();
      }
    }).catch(msj => {
      console.log(msj);
    });
    
  }

  const handleChangeCondicion = (e) => {
    if(e === null) { setCondicion('SinSelecc');}else{
      setCondicion(e);  
    }
    
  }


  const handleCloseElimina = () => {
    setoOpenElimina(false);
  }

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  useEffect(() => {
    console.log(del);
  }, [del]);

  return (
    <>
      <div
        style={{
          marginLeft: "5%",
          marginRight: "5%",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "15px",
        }}
      >
        <Panel bordered header="Creación de Horarios">
          <div className="row">
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Fecha inicial</Text>
              <CustomProvider locale={es_ES}>
                <DatePicker
                  block
                  shouldDisableDate={handleDisabledDate}
                  onChange={(e) => setFec1(e)}
                />
              </CustomProvider>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Fecha final</Text>
              <CustomProvider locale={es_ES}>
                <DatePicker
                  block
                  shouldDisableDate={handleDisabledDate}
                  onChange={(e) => setFec2(e)}
                />
              </CustomProvider>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Condición</Text>
              <SelectPicker
                data={dataCondcion}
                block
                searchable={false}
                value={condicion}
                defaultValue={'SinSelecc'}
                placeholder="Selecciona"
                onChange={(e) => handleChangeCondicion(e)}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Duración</Text>
              <InputNumber
                min={0}
                value={duracion}
                onChange={(e) => setDuracion(e)}
              />
              <span style={{ fontSize: "12px" }}>Minutos</span>
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Hora Inicio</Text>
              <Input
                placeholder="00:00"
                maxLength={5}
                value={horaIni}
                onChange={(e) => maskTime(e, "ini")}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Última hora</Text>
              <Input
                placeholder="00:00"
                maxLength={5}
                value={horaFin}
                onChange={(e) => maskTime(e, "fin")}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Ini. comida</Text>
              <Input
                placeholder="00:00"
                maxLength={5}
                value={horaIniCom}
                onChange={(e) => maskTime(e, "iniCom")}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Fin comida</Text>
              <Input
                placeholder="00:00"
                maxLength={5}
                value={horaFinCom}
                onChange={(e) => maskTime(e, "finCom")}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <br />
              <Button
                appearance="primary"
                onClick={save}
                loading={loading}
                block
                startIcon={<FaSave></FaSave>}
              >
                Guardar
              </Button>
            </div>
          </div>
        </Panel>
      </div>
      <br />
      <div
        style={{
          marginLeft: "5%",
          marginRight: "5%",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "15px",
        }}
      >
        <Panel header="Consulta de Horarios de Servicio" bordered>
          <div className="row mb-2">
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Del</Text>
              <CustomProvider locale={es_ES}>
                <DatePicker value={del} onChange={(e) => setDel(e)} />
              </CustomProvider>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Al</Text>
              <CustomProvider locale={es_ES}>
                <DatePicker value={al} onChange={(e) => setAl(e)} />
              </CustomProvider>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3">
              <Text size={"md"}>Filtro de búsqueda</Text>
              <SelectPicker
                block
                searchable={false}
                data={dataFiltro}
                onChange={(e) => setFiltro(e)}
                value={filtro}
                placeholder="Todos los días"
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <br></br>
              <Button appearance="primary" onClick={getHorarios}>
                <FaSearch></FaSearch>&nbsp; Buscar
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Table
                height={300}
                hover={true}
                showHeader={true}
                data={data}
                loading={dataLoading}
                bordered={true}
                cellBordered={true}
                headerHeight={30}
                rowHeight={40}
              >
                <Column flexGrow={1} sortable>
                  <HeaderCell align="center">Fecha</HeaderCell>
                  <Cell dataKey="fecha" align="center" />
                </Column>

                <Column flexGrow={1} sortable>
                  <HeaderCell>Día</HeaderCell>
                  <Cell dataKey="diaSemana"></Cell>
                </Column>

                <Column flexGrow={1} resizable sortable>
                  <HeaderCell align="center">Horario</HeaderCell>
                  <Cell dataKey="hora" align="center" />
                </Column>

                <Column flexGrow={1} resizable sortable>
                  <HeaderCell align="center">Espacios</HeaderCell>
                  <Cell dataKey="espacios" align="center" />
                </Column>

                <Column flexGrow={1} resizable sortable>
                  <HeaderCell align="center">Duración</HeaderCell>
                  <Cell dataKey="intervarlo" align="center" />
                </Column>

                <Column width={100} fixed>
                  <HeaderCell align="center">Acción</HeaderCell>
                  <Cell style={{ padding: "6px" }} align="center">
                    {(rowData) => (
                      <Button
                        appearance="subtle"
                        size="sm"
                        onClick={() =>
                          cancelarHorario({
                            id: idNegocio,
                            fecha: rowData.fecha,
                            espacio: rowData.espacios,
                            hora: rowData.hora,
                          })
                        }
                      >
                        <FaTrash style={{ color: "red" }} />
                      </Button>
                    )}
                  </Cell>
                </Column>
              </Table>
            </div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <Text color="red" size="lg">
                * Nota: Solo se eliminaran aquellos horarios que no se
                encuentren agendados.
              </Text>
            </div>
            <div className="text-end col-lg-6 col-md-6 col-sm-6">
              <Button
                appearance="primary"
                color="red"
                disabled={habilitarElimina}
                onClick={() => handleOpenElimina(true)}
              >
                Eliminar horarios
              </Button>
            </div>
          </div>
        </Panel>
      </div>
      <Modal centered size="xs" open={openElimina} onClose={handleCloseElimina}>
        <Modal.Header>
          <Modal.Title>Eliminar horarios</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text size="md" color="red">{pregunta}</Text>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCloseElimina} appearance="subtle">
            Cerrar
          </Button>
          <Button disabled={disabledSi} onClick={()=> deleteHorarios()} appearance="primary">
            Si
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
